import script from "./investStat.vue?vue&type=script&lang=ts&setup=true"
export * from "./investStat.vue?vue&type=script&lang=ts&setup=true"

import "./investStat.vue?vue&type=style&index=0&id=78f52988&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f52988"]])

export default __exports__